export default __webpack_public_path__ + "static/O0126-e15c4f4855720ceb5f7d91df42c30dae.png";